export default "__VITE_ASSET__BLG3c1D2__"